var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0664 4C9.81878 4 9.58131 4.10862 9.40622 4.30196C9.23113 4.49531 9.13277 4.75754 9.13277 5.03097C9.13277 5.3044 9.23113 5.56663 9.40622 5.75997C9.58131 5.95332 9.81878 6.06194 10.0664 6.06194C10.314 6.06194 10.5515 5.95332 10.7266 5.75997C10.9016 5.56663 11 5.3044 11 5.03097C11 4.75754 10.9016 4.49531 10.7266 4.30196C10.5515 4.10862 10.314 4 10.0664 4ZM9.84232 7.27848C9.10165 7.34721 7.07882 9.12735 7.07882 9.12735C6.95434 9.23045 6.99168 9.22357 7.09127 9.41602C7.19086 9.6016 7.17841 9.61534 7.29667 9.52599C7.42115 9.43664 7.62654 9.2923 7.96887 9.05862C9.28837 8.12387 8.18049 10.282 7.61409 13.9179C7.39003 15.7187 8.85891 14.7908 9.23858 14.5159C9.61203 14.2478 10.6141 13.4849 10.7137 13.4093C10.8506 13.3062 10.751 13.2237 10.6452 13.0519C10.5705 12.9351 10.4958 13.0175 10.4958 13.0175C10.0913 13.3131 9.35062 13.9317 9.25103 13.5399C9.13277 13.1481 9.89211 10.4607 10.3091 8.61187C10.3776 8.17199 10.5643 7.20975 9.84232 7.27848Z",
    fill: "#00A03B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "#00A03B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreen);
export default __webpack_public_path__ + "static/media/infoGreen.4eb9676fd874b54dad4c02705d13f088.svg";
export { ForwardRef as ReactComponent };